import React, { useState, useEffect } from 'react';
import { Spin } from 'antd';
import EmptyState from '../components/EmptyState';
import PageHeader from '../components/PageHeader';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../styles/common-page.css';
import CeremonyCard from '../components/CeremonyCard';
import VillageIllustration from '../components/VillageIllustration';
import axiosInstance from '../services/axios';
import ceremonyImage from '../assets/images/ceremony.png';

const Ceremony = () => {
  const { i18n } = useTranslation();
  const [ceremonyList, setCeremonyList] = useState([]);
  const [loading, setLoading] = useState(true);

  const content = {
    en: {
      homepage: 'Homepage',
      title: 'Ceremonies',
      footerAlt: 'Footer Image'
    },
    mr: {
      homepage: 'मुख्यपृष्ठ',
      title: 'कार्यक्रम',
      footerAlt: 'तळ चित्र'
    }
  };

  const currentContent = content[i18n.language] || content.mr;

  useEffect(() => {
    const fetchCeremonies = async () => {
      try {
        setLoading(true);
        const language = i18n.language === 'mr' ? 'Marathi' : 'English';
        const response = await axiosInstance.get('/ceremonies/', {
          params: { language }
        });

        const data = response.data;
        console.log('Ceremonies API response:', data);

        if (data && data.length > 0) {
          const mapped = data.map(item => ({
            id: item.id,
            imgSrc: item.cover_image || ceremonyImage,
            title: item.title,
            description: item.description || '',
            routeLink: `/ceremony/${item.id}`,
            detailLink: `/ceremony/${item.id}`,
            label: i18n.language === 'en' ? 'Share on WhatsApp' : 'व्हॉट्सअप करा'
          }));
          setCeremonyList(mapped);
        }
      } catch (err) {
        console.error('Error fetching ceremonies:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCeremonies();
  }, [i18n.language]);

  return (
    <div className="bg-image-section">
      <div className="flex flex-col gap-4 section-padding">
        <PageHeader
          breadcrumb={[
            <Link key="home" to="/">{currentContent.homepage}</Link>,
            <span key="ceremony">{currentContent.title}</span>
          ]}
          title={currentContent.title}
        />

        {/* Ceremony List */}
        {loading ? (
          <div style={{ textAlign: 'center', padding: '50px' }}>
            <Spin size="large" />
          </div>
        ) : ceremonyList.length === 0 ? (
          <div style={{ padding: '50px 0' }}>
            <EmptyState description={i18n.language === 'mr' ? 'डेटा लवकरच उपलब्ध होईल' : 'Data will be available soon'} />
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {ceremonyList.map((item) => (
              <CeremonyCard
                key={item.id}
                imgSrc={item.imgSrc}
                title={item.title}
                description={item.description}
                label={item.label}
                shareLink={item.shareLink}
                detailLink={item.detailLink}
                className=""
              />
            ))}
          </div>
        )}

        <div />
      </div>

      <VillageIllustration />
    </div>
  );
};

export default Ceremony;
